// Read-more component: toggle the hidden remainder open and closed.
export default function readMore() {
	document.addEventListener('click', (e) => {
		const btn = e.target.closest('.read-more__toggle');

		if (!btn) {
			return;
		}

		const wrapper = btn.closest('.read-more');
		const more = wrapper && wrapper.querySelector('.read-more__more');
		const label = btn.querySelector('.read-more__toggle-label');

		if (!more) {
			return;
		}

		const expand = more.hidden;
		more.hidden = !expand;
		btn.setAttribute('aria-expanded', expand ? 'true' : 'false');

		if (label) {
			if (expand) {
				btn.dataset.labelExpand = label.textContent;
				label.textContent = btn.dataset.labelCollapse || label.textContent;
			} else {
				label.textContent = btn.dataset.labelExpand || label.textContent;
			}
		}
	});
}
